import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Perfil from './components/Perfil';
import DashboardMasajista from './components/DashboardMasajista';
import DashboardPaciente from './components/DashboardPaciente';
import AdminMasajistas from './components/AdminMasajistas';
import ResetPassword from './components/ResetPassword';
import AdminLayout from './components/AdminLayout';
import UserManagement from './components/UserManagement';
import { ThemeProvider } from './contexts/ThemeContext';
import VerifyEmail from './components/VerifyEmail';
import AdminTurnos from './components/AdminTurnos';
import AdminPagos from './components/AdminPagos';
import AdminReportes from './components/AdminReportes';
import MisTurnos from './components/MisTurnos';
import ListaMasajistas from './components/ListaMasajistas';
import ReservarTurno from './components/ReservarTurno';
import MiAgenda from './components/MiAgenda';
import AdminServicios from './components/AdminServicios';
import AdminAgenda from './components/AdminAgenda';



// Componente para redirección inicial según rol
const HomeRedirect = () => {
    const { user, loading } = useAuth();
    if (loading) return <div>Cargando...</div>;
    if (!user) return <Navigate to="/login" />;
    return <Navigate to={`/${user.role}`} />;
};

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ThemeProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:token" element={<ResetPassword />} />
                        <Route path="/verificar-email/:token" element={<VerifyEmail />} />

                        {/* Rutas protegidas por rol */}
                        <Route path="/admin" element={
                            <PrivateRoute roles={['admin']}>
                                <AdminLayout />
                            </PrivateRoute>
                        }>
                            <Route index element={<Navigate to="usuarios" />} />
                            <Route path="usuarios" element={<UserManagement />} />
                            <Route path="masajistas" element={<AdminMasajistas />} />
                            <Route path="turnos" element={<AdminTurnos />} />
                            <Route path="pagos" element={<AdminPagos />} />
                            <Route path="reportes" element={<AdminReportes />} />
                            <Route path="servicios" element={<AdminServicios />} />
                            <Route path="agenda" element={<AdminAgenda />} />
                            {/* futuros módulos acá */}
                        </Route>

                        <Route path="/masajista" element={
                            <PrivateRoute roles={['masajista']}>
                                <DashboardMasajista />
                            </PrivateRoute>
                        }>
                            <Route index element={<Navigate to="turnos" replace />} />
                            <Route path="turnos" element={<MisTurnos />} />
                            <Route path="agenda" element={<MiAgenda />} />
                        </Route>

                        <Route path="/paciente" element={
                            <PrivateRoute roles={['paciente']}>
                                <DashboardPaciente />
                            </PrivateRoute>
                        }>
                            <Route index element={<Navigate to="nuevo-turno" replace />} />
                            <Route path="nuevo-turno" element={<ListaMasajistas />} />
                            <Route path="reservar/:id" element={<ReservarTurno />} />
                            <Route path="mis-turnos" element={<MisTurnos />} />
                        </Route>

                        {/* Ruta de perfil (cualquier usuario autenticado) */}
                        <Route
                            path="/perfil"
                            element={
                                <PrivateRoute>
                                    <Perfil />
                                </PrivateRoute>
                            }
                        />
                        {/* Ruta raíz */}
                        <Route path="/verificar-email/:token" element={<VerifyEmail />} />
                        <Route path="/" element={<HomeRedirect />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </ThemeProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;